module.exports = __webpack_public_path__ + "static/media/sendSymbol.f21731ad.svg";